/* eslint-disable no-console */
import React from "react";
import { PropTypes } from "prop-types";
import { Logo } from "@bca/ui-library";
import { useDispatch } from "react-redux";
import {
  StyledMenu,
  StyledMenuHeader,
  StyledMobileLink,
  StyledMobileLinkContainer,
  StyledMobileSpace,
  StyledNewIcon,
  StyledSpace,
  StyledTitle,
} from "./Menu.styled";
import { resetForm } from "../../reducers/formSlice";

const Menu = ({
  headerHomeUrl,
  headerHomeText,
  onCloseClick,
  menuHomeText,
}) => {
  const dispatch = useDispatch();

  return (
    <StyledMenu>
      <StyledMenuHeader>
        <Logo />
        <StyledSpace />
        <StyledNewIcon name="close" size="md" onClick={onCloseClick} />
      </StyledMenuHeader>
      <StyledTitle>{menuHomeText}</StyledTitle>
      <StyledMobileLinkContainer key={headerHomeUrl}>
        <StyledMobileLink
          href={headerHomeUrl}
          onClick={() => dispatch(resetForm())}
        >
          {headerHomeText}
          <StyledMobileSpace />
          <StyledNewIcon name="chevron-right" size="md" />
        </StyledMobileLink>
      </StyledMobileLinkContainer>
    </StyledMenu>
  );
};

Menu.propTypes = {
  headerHomeUrl: PropTypes.string.isRequired,
  headerHomeText: PropTypes.string.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  menuHomeText: PropTypes.string.isRequired,
};

export default Menu;
